import { api } from './api';
import { unauthorizedError } from './state';

export const getNotes = () => (dispatch) => {
  return api
    .get('/notes')
    .then((response) => {
      dispatch({ type: 'GET_NOTES', data: response.data });
    })
    .catch(function (error) {
      dispatch({ type: 'GET_NOTES_ERROR' });
      alert(error);
      if (error.response) {
        if (error.response.status === 401) {
          dispatch(unauthorizedError());
        }
      }
      return [];
    });
};

export const updateNotes = (selectedItem) => (dispatch) => {
  api
    .put('/notes', selectedItem)
    .then((response) => {
      dispatch({ type: 'UPDATE_NOTES' });
      alert('Updated');
      dispatch(getNotes());
    })
    .catch(function (error) {
      alert('Update ERROR');
      alert(error);
      dispatch({ type: 'UPDATE_NOTES_ERROR' });
      if (error.response) {
        if (error.response.status === 401) {
          dispatch(unauthorizedError());
        }
      }
    });
};

export const getAppversion = () => (dispatch) => {
  return api
    .get('/appversion')
    .then((response) => {
      dispatch({ type: 'GET_APPVERSION', data: response.data });
    })
    .catch(function (error) {
      dispatch({ type: 'GET_APPVERSION_ERROR' });
      alert(error);
      if (error.response) {
        if (error.response.status === 401) {
          dispatch(unauthorizedError());
        }
      }
      return [];
    });
};

export const updateAppversion = (appversion) => (dispatch, getState) => {
  api
    .put('/appversion', {
      version: appversion,
    })
    .then((response) => {
      dispatch({ type: 'UPDATE_APPVERSION' });
      alert('Updated');
      dispatch(getAppversion());
    })
    .catch(function (error) {
      alert('Update ERROR');
      alert(error);
      dispatch({ type: 'UPDATE_APPVERSION_ERROR' });
      if (error.response) {
        if (error.response.status === 401) {
          dispatch(unauthorizedError());
        }
      }
    });
};

export const getSettings = () => (dispatch) => {
  return api
    .get('/settings')
    .then((response) => {
      dispatch({ type: 'GET_SETTINGS', data: response.data });
    })
    .catch(function (error) {
      dispatch({ type: 'GET_SETTINGS_ERROR' });
      alert(error);
      if (error.response) {
        if (error.response.status === 401) {
          dispatch(unauthorizedError());
        }
      }
      return [];
    });
};

export const updateSettings = (selectedItem) => (dispatch) => {
  api
    .put('/settings', selectedItem)
    .then((response) => {
      dispatch({ type: 'UPDATE_SETTINGS' });
      alert('Updated');
      dispatch(getSettings());
    })
    .catch(function (error) {
      alert('Update ERROR');
      alert(error);
      dispatch({ type: 'UPDATE_SETTINGS_ERROR' });
      if (error.response) {
        if (error.response.status === 401) {
          dispatch(unauthorizedError());
        }
      }
    });
};
